import React from 'react'

export default function Mic({ className }) {
  return (
    <svg viewBox="0 0 12 16" className={className}>
      <path
        fill="currentColor"
        d="M10.000,16.000 C8.895,16.000 8.000,15.104 8.000,14.000 L8.000,2.000 C8.000,0.895 8.895,-0.000 10.000,-0.000 C11.104,-0.000 12.000,0.895 12.000,2.000 L12.000,14.000 C12.000,15.104 11.104,16.000 10.000,16.000 ZM2.000,16.000 C0.895,16.000 -0.000,15.104 -0.000,14.000 L-0.000,2.000 C-0.000,0.895 0.895,-0.000 2.000,-0.000 C3.105,-0.000 4.000,0.895 4.000,2.000 L4.000,14.000 C4.000,15.104 3.105,16.000 2.000,16.000 Z"
      />
    </svg>
  )
}
